// types
import { IEnergyOverview } from './types'
import {  ParagraphMedium } from 'baseui/typography';
// components
import { CounterType } from '../../Devices/CounterType';
import { LoadingView } from '../../../components/LoadingView'
import {  useMemo } from 'react';
import { ICounter } from '../../../automationObjects/Devices/Counter';
import { FormattedMessage } from 'react-intl';
import { EnergyBarChart } from './';
import { useGetObjectsChildren } from '../../../hooks/useGetObjectsChildren';
import { defaultCurrencyCode } from '../../../utils/currency';

export interface SmallPanelProps extends IEnergyOverview {
    showChart: boolean,
}
export function SmallPanel(props: SmallPanelProps) {

    const squareMeter = props.squereMeter;
    //const { objects:objects, error, isLoading, isSuccess } = useGetObjectsBySchemaFromParent(props.resourceGroupId, objectId, schema);
    const { children: objects, isLoading, isSuccess, error } = useGetObjectsChildren(props.resourceGroupId, props.id)


    const { allItems } = useMemo(() => {
        if (objects) {
            const items = [...objects].sort((a: ICounter, b: ICounter) => a.counterMedium > b.counterMedium ? 1 : -1);
            const consumedItems = [...items].filter((item, index) => item.counterType === CounterType.FeedIn);
            const producedItems = [...items].filter((item, index) => item.counterType === CounterType.FeedOut);
            const allItems = [...consumedItems, ...producedItems];
            return { allItems };
        }
        const allItems = []
        return { allItems }
    }, [objects]);


    const currency = props.currencyCode ?? defaultCurrencyCode;

    return (
        <LoadingView isLoading={isLoading} isSucess={isSuccess} error={error}>
            <>
               {/*} <ParagraphMedium marginBottom={0}><FormattedMessage id="EnergyOverview.MonthlyCosts" defaultMessage="Monthly energy costs" /></ParagraphMedium>*/}
                <EnergyBarChart currencyCode={currency} showChart={props.showChart} dimension='€' squareMeter={squareMeter} counters={allItems} propertyName={'actCostsConsumption'}></EnergyBarChart>
            </>
        </LoadingView>
    );
}

